"use client"

import * as SwitchPrimitive from "@radix-ui/react-switch"
import * as React from "react"

import { cn } from "../../utils"

function Switch({ className, ...props }: React.ComponentProps<typeof SwitchPrimitive.Root>) {
	return (
		<SwitchPrimitive.Root
			data-slot="switch"
			className={cn(
				"peer inline-flex h-5 w-8 shrink-0 items-center rounded-full outline-none cursor-pointer transition-colors",
				"data-[state=checked]:bg-p600 data-[state=unchecked]:bg-black/20 data-[state=unchecked]:hover:bg-black/50",
				"dark:data-[state=checked]:bg-p500 dark:data-[state=unchecked]:bg-white/20 dark:data-[state=unchecked]:hover:bg-white/50",
				"disabled:cursor-not-allowed data-[state=checked]:disabled:bg-g200 data-[state=unchecked]:disabled:bg-g200",
				"dark:data-[state=checked]:disabled:bg-g200 dark:data-[state=unchecked]:disabled:bg-g200",
				className
			)}
			{...props}
		>
			<SwitchPrimitive.Thumb
				data-slot="switch-thumb"
				className={cn(
					"bg-white pointer-events-none block size-4 rounded-full transition-transform data-[state=checked]:translate-x-[calc(100%-2px)] data-[state=unchecked]:translate-x-[2px]",
					"shadow-[0px_0px_4px_0px_rgb(var(--black)_/_0.2)]",
					"data-[disabled]:bg-g400"
				)}
			/>
		</SwitchPrimitive.Root>
	)
}

export { Switch }
